export const vote =
{
    path: "/vote",
    component: () => import("@/views/vote/vote"),
    meta: {
        hidden: true,
    },

}
export const eventDetails =
{
    path: "/eventDetails",
    component: () => import("@/views/vote/eventDetails"),
    meta: {
        hidden: true,
    },
}
